import Immutable from 'immutable';
import {
  FETCH_USER_KUDOS_FOR_COURSE_START,
  FETCH_USER_KUDOS_FOR_COURSE_SUCCESS,
  FETCH_USER_KUDOS_FOR_COURSE_FAILURE,
} from './actions';
import { FetchStatus } from './constants';

export function Kudos(state = Immutable.Map(), action) {
  switch (action.type) {
    case FETCH_USER_KUDOS_FOR_COURSE_SUCCESS: {
      const { kudos, coursePath } = action;
      return state.mergeIn(
        [coursePath],
        Immutable.fromJS({
          kudos,
          status: FetchStatus.SUCCESS,
        })
      );
    }

    case FETCH_USER_KUDOS_FOR_COURSE_START: {
      const { coursePath } = action;
      return state.set(
        coursePath,
        Immutable.Map({
          status: FetchStatus.LOADING,
        })
      );
    }

    case FETCH_USER_KUDOS_FOR_COURSE_FAILURE: {
      const { coursePath /* , error */ } = action;
      return state.mergeIn(
        [coursePath],
        Immutable.fromJS({
          status: FetchStatus.FAILURE,
          error: true,
        })
      );
    }

    default: {
      return state;
    }
  }
}
